export default __webpack_public_path__ + "static/media/35_photo.dd05960b.jpeg";